var map = {
	"./ajudar.PNG": 133,
	"./ecoponto.jpg": 134,
	"./ecosound.png": 135,
	"./eliminado.png": 136,
	"./embalao.jpg": 137,
	"./ilhas.jpg": 138,
	"./indiferido.png": 139,
	"./papelao.jpg": 140,
	"./papelaoembalao.jpg": 141,
	"./pending.png": 142,
	"./suspenso.png": 143,
	"./vidrao.jpg": 144,
	"./vidraoembalao.jpg": 145,
	"./vidraopapelao.jpg": 146
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 170;



//////////////////
// WEBPACK FOOTER
// ./src/ecopontos/images .*
// module id = 170
// module chunks = 0